import { render } from "./ContactTab.vue?vue&type=template&id=285b8d55&scoped=true"
import script from "./ContactTab.vue?vue&type=script&lang=js"
export * from "./ContactTab.vue?vue&type=script&lang=js"

import "./ContactTab.vue?vue&type=style&index=0&id=285b8d55&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-285b8d55"]])

export default __exports__